import * as React from 'react';

export const IcaMapPin = React.forwardRef<
  SVGSVGElement,
  {
    selected: boolean;
    ariaName?: string;
  }
>(({ selected, ariaName }, ref) => {
  if (selected) {
    return (
      <svg ref={ref} width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{ariaName}</title>
        <g opacity=".12" filter="url(#filter0_f)">
          <ellipse cx="24" cy="40" rx="16" ry="4" fill="#000" />
        </g>
        <path
          d="M23.43.01C15.46.29 8.84 6.49 8.076 14.404a16.01 16.01 0 00.32 5.084 15.966 15.966 0 001.078 3.166c1.604 3.79 5.313 10.129 13.635 17.026.51.427 1.258.427 1.776 0 8.322-6.889 12.031-13.229 13.643-17.034.469-1 .83-2.059 1.077-3.166.074-.32.107-.5.107-.5.19-.984.288-1.993.288-3.026C40 6.949 32.525-.31 23.43.01z"
          fill="#ED1C24"
        />
        <circle cx="24" cy="16" fill="#ED1C24" r="16" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.128 13.372c.193.04.309.064.527-.022.149-.056.652-.942.774-1.194.13-.242.121-.54-.466-.755a4.555 4.555 0 00-1.586-.27c-1.427 0-4.327 1.1-4.327 4.486 0 3.385 3.05 4.355 4.411 4.355 1.352 0 2.91-.784 3.581-1.875.672-1.063 1.53-2.592 1.53-2.592l.942 1.771h-.644l-.858 1.53h2.406s.373.933 1.129.933h1.893L28.525 11s-2.9 5.335-3.17 5.736c-.271.4-.887 1.1-1.95 1.1s-2.257-.858-2.257-2.257c0-1.408.951-2.285 2.229-2.285.375 0 .59.045.751.078zM18.23 11.28H16v8.57h2.229v-8.57z"
          fill="#fff"
        />
        <defs>
          <clipPath id="clip0">
            <path fill="#fff" d="M0 0h48v48H0z" />
          </clipPath>
          <filter
            id="filter0_f"
            x="2"
            y="30"
            width="44"
            height="20"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur" />
          </filter>
        </defs>
      </svg>
    );
  } else {
    return (
      <svg ref={ref} width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{ariaName}</title>
        <g opacity=".12" filter="url(#filter0_f)">
          <ellipse cx="24" cy="36" rx="12" ry="3" fill="#000" />
        </g>
        <path
          d="M23.572 6.008c-5.976.209-10.941 4.859-11.515 10.795a12.007 12.007 0 00.24 3.813c.186.825.463 1.624.809 2.375 1.202 2.841 3.984 7.596 10.226 12.77.382.319.943.319 1.332 0 6.241-5.168 9.023-9.923 10.232-12.777.352-.75.623-1.543.808-2.374.056-.24.08-.375.08-.375.142-.738.216-1.495.216-2.27 0-6.754-5.606-12.197-12.428-11.957z"
          fill="#ED1C24"
        />
        <circle cx="24" cy="18" fill="#ED1C24" r="12" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.096 16.03c.145.03.232.047.395-.017.112-.042.49-.707.58-.896.098-.182.091-.405-.35-.566a3.413 3.413 0 00-1.188-.203c-1.07 0-3.246.825-3.246 3.364 0 2.54 2.288 3.267 3.309 3.267 1.014 0 2.182-.588 2.686-1.406.503-.797 1.147-1.945 1.147-1.945l.706 1.33h-.482l-.644 1.147h1.805s.28.699.846.699h1.42l-3.686-6.554s-2.175 4-2.378 4.302c-.203.3-.665.825-1.462.825-.798 0-1.693-.643-1.693-1.693 0-1.056.713-1.713 1.672-1.713.28 0 .442.033.563.058zm-4.424-1.57H18v6.428h1.672V14.46z"
          fill="#fff"
        />
        <defs>
          <clipPath id="clip0">
            <path fill="#fff" transform="translate(6 6)" d="M0 0h36v36H0z" />
          </clipPath>
          <filter
            id="filter0_f"
            x="6"
            y="27"
            width="36"
            height="18"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="3" result="effect1_foregroundBlur" />
          </filter>
        </defs>
      </svg>
    );
  }
});
